"use client";

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";

export default function EditModeButton() {
    const handleEditClick = () => {
        // Get current URL and add editmode=true
        const url = new URL(window.location.href);
        url.searchParams.set("editmode", "true");
        
        // Perform a hard refresh by changing window.location
        window.location.href = url.toString();
    };

    return (
        <div
            className="z-[9999999] fixed bottom-5 px-8 py-2.5 right-5 rounded-full bg-primary text-primary-foreground text-black p-2 flex items-center gap-4 shadow-2xl cursor-pointer hover:-translate-y-1 transition-all duration-200"
            onClick={handleEditClick}
        >
            <FontAwesomeIcon icon={faPencil} size="lg" />
            <p className="text-2xl">Edit</p>
        </div>
    );
} 